/**
 * Routing.
 *
 * Deliberately no router library: there are four states — verifying a link, signed out,
 * signed in for the first time, and signed in — and a dependency to express that would be
 * more moving parts than the problem has.
 */

import { SessionProvider, useSession } from './lib/session.js';
import { Shell } from './components/Shell.js';
import { SignIn } from './pages/SignIn.js';
import { VerifyLink } from './pages/VerifyLink.js';
import { Availability } from './pages/Availability.js';
import { Onboarding } from './pages/Onboarding.js';
import { AdminApp } from './pages/admin/AdminApp.js';
import './styles/app.css';

function Routes() {
  const { instructor, loading } = useSession();

  // The dashboard is a different app with a different identity (SPEC §9.4), so it is
  // resolved before the instructor session is even looked at — Luke is frequently signed in
  // as both, and neither should influence the other.
  if (window.location.pathname.startsWith('/admin')) return <AdminApp />;

  // Handled before the loading check: an instructor arriving from their email should see
  // "Signing you in…" immediately, not a blank flash followed by a sign-in form.
  if (window.location.pathname.startsWith('/signin/verify')) return <VerifyLink />;

  if (loading) return <p className="muted center">Loading…</p>;
  if (!instructor) return <SignIn />;

  // Shown once, and only completed at the end of the wizard — closing the tab midway leaves
  // it in place rather than stranding a half-onboarded instructor on a blank calendar with
  // no pattern and no route back to the screen that would fix it (SPEC §11.3).
  if (instructor.needsOnboarding) return <Onboarding />;

  return <Availability />;
}

export function App() {
  return (
    <SessionProvider>
      <Shell>
        <Routes />
      </Shell>
    </SessionProvider>
  );
}
